// extracted by mini-css-extract-plugin
module.exports = {"question":"style_question__1eyZ_","invalidValue":"style_invalidValue__1L9hN"};